export { default } from "./ProfileInfo-container";
